import React, { useEffect } from 'react';
import { IItemForGetShortInfoWithStatus, ITotalPrice, IGetRestaurantsShortArgs } from 'types';
import { IGetRestaurantsShort } from 'types';
import { getRestaurantsShortInfo } from 'backend/restaurants';
import { useFetchData } from 'hooks/useFetchData';
import MultipleSelect from './components/MultipleSelect';
import style from './RestaurantsMultipleSelect.module.scss';

interface IRestaurantsMultipleSelect {
	setFetchedRestaurants: (value: IItemForGetShortInfoWithStatus[]) => void;
	selectedCustomer: Nullable<string>;
	setRestaurantsForPrice: (value: string[]) => void;
	removePrice: (value: string[]) => void;
	restaurantsForPrice: string[];
	totalPrices: ITotalPrice[];
	isCreatedInPos: boolean;
}

const RestaurantsMultipleSelect: React.FC<IRestaurantsMultipleSelect> = ({
	selectedCustomer,
	setFetchedRestaurants,
	totalPrices,
	restaurantsForPrice,
	setRestaurantsForPrice,
	removePrice,
	isCreatedInPos,
}) => {
	const { response, loading, refetch, responseError } = useFetchData<IGetRestaurantsShort, IGetRestaurantsShortArgs>(
		selectedCustomer ? getRestaurantsShortInfo : null,
		{
			customerId: selectedCustomer || '',
			menuApiVersion: 'v1',
		},
	);

	useEffect(() => {
		refetch();
	}, [selectedCustomer]);

	useEffect(() => {
		if (response) {
			setFetchedRestaurants(response.data.restaurants);
		}
	}, [response]);

	return (
		<div className={style.container}>
			<div className={style.field}>
				<MultipleSelect
					data={response?.data.restaurants || []}
					isLoading={loading}
					refetch={refetch}
					responseError={responseError}
					restaurantsForPrice={restaurantsForPrice}
					totalPrices={totalPrices}
					selectedCustomer={selectedCustomer}
					removePrice={removePrice}
					setRestaurantsForPrice={setRestaurantsForPrice}
					isCreatedInPos={isCreatedInPos}
				/>
			</div>
		</div>
	);
};

export default React.memo(RestaurantsMultipleSelect);
